import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ConsultasPage from "./pages/ConsultasPage";
import MicrosoftIdentityAssociationFile from "./pages/consultas/microsoft-identity-association";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [isConsultasSubdomain, setIsConsultasSubdomain] = useState(false);

  useEffect(() => {
    // Detectar si el subdominio es "consultas"
    const hostname = window.location.hostname;
    const subdomain = hostname.split('.')[0];
    
    if (subdomain === 'consultas') {
      setIsConsultasSubdomain(true);
    }
  }, []);

  // Si es subdominio consultas, mostrar solo ConsultasPage
  if (isConsultasSubdomain) {
    return (
      <Router>
        <div>
          <Routes>
            <Route path="/" element={<ConsultasPage />} />
            <Route path=".well-known/microsoft-identity-association.json" element={<MicrosoftIdentityAssociationFile />} />
            <Route path="*" element={<ConsultasPage />} />
          </Routes>
        </div>
      </Router>
    );
  }

  // Configuración normal para el dominio principal
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/consultas" element={<ConsultasPage />} />
          <Route path=".well-known/microsoft-identity-association.json" element={<MicrosoftIdentityAssociationFile />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
